import React from 'react';
import Page404 from '../Images/404.gif'

const PageNotFound= () =>{
    return (
        <>
            <div>
                <img src={Page404} alt={""} className="page-not-found"/>
            </div>
        </>
    )
}

export default PageNotFound;